/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * application
 * OpenAPI spec version: 1.0.0-20260821-095530-09d45749
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import { useMutator } from '../../useMutator';
import { useCreateMutationOptions } from '../../client/mutationOptions';
export interface UpdateEmailNotificationPreference {
  emailAddress: string;
  enabled: boolean;
}

export interface Address {
  houseNumberSuffix: string;
  street: string;
  houseNumber: string;
  postalCode: string;
  lines?: string[];
  city: string;
  countryCode: string;
}

export interface NotificationPreferences {
  userId: string;
  pushNotificationPreference: PushNotificationPreference;
  emailNotificationPreferences?: EmailNotificationPreference[];
}

export interface ProfileMobilePhone {
  number: string;
  isVerificationPending: boolean;
  isValidationRequired: boolean;
}

export interface CompletedInteraction {
  name: string;
  completedAt: string;
}

export interface PushNotificationPreference {
  isEnabledForIncomingParcels: boolean;
  isEnabledForOutgoingParcels: boolean;
}

export interface ProfileAddress {
  name: string;
  addressDetails: ProfileAddressDetails;
  isDefaultShippingAddress: boolean;
  addressId: string;
  address: Address;
}

export interface UpdatePushNotificationPreference {
  enabledForIncomingParcels: boolean;
  enabledForOutgoingParcels: boolean;
}

export interface ProfileAddressDetails {
  companyName?: string;
  email: string;
  vatNumber?: string;
  firstName: string;
  mobileNumber?: string;
  lastName: string;
}

export interface AddressRequest {
  name: string;
  isDefaultShippingAddress: boolean;
  address: Address;
  addressDetails?: ProfileAddressDetails;
}

export interface EmailNotificationPreference {
  emailAddress: string;
  isEnabled: boolean;
}

export interface VerifyMobilePhoneRequest {
  verificationToken: string;
}

export interface AdditionalEmailRequest {
  email: string;
}

export interface ReceiverProfile {
  firstName: string;
  lastName: string;
  email: string;
  userId: string;
  version: number;
  updatedAt: string;
  completedInteractions?: CompletedInteraction[];
  guidedTour: GuidedTour;
  addresses?: ProfileAddress[];
  mobilePhone?: ProfileMobilePhone;
  userType: string;
  createdAt: string;
  emailAddresses?: ProfileEmailAddress[];
}

export interface GuidedTour {
  completedTours?: CompletedTour[];
}

export interface ProfileEmailAddress {
  emailId: string;
  email: string;
  isVerificationPending: boolean;
  isPrimary: boolean;
}

export interface CompletedTour {
  name: string;
  completedAt: string;
}

export interface AppError {
  key: string;
  message: string;
}

export interface MobilePhoneRequest {
  mobileNumber: string;
}

export type GetProfileUseridEmailAddressesEmailidVerifyParams = {
email: string;
token: string;
successRedirectPath?: string;
failureRedirectPath?: string;
'x-lang'?: string;
};

export type PutProfileEmailAddressesEmailidReActivateParams = {
'x-lang'?: string;
};

export type PostProfileEmailAddressesParams = {
'x-lang'?: string;
};

export type PutProfileMobilePhoneReActivateParams = {
'x-lang'?: string;
};

export type PostProfileMobilePhoneParams = {
'x-lang'?: string;
};

export type GetProfileUseridEmailAddressesEmailidRetractParams = {
successRedirectPath?: string;
failureRedirectPath?: string;
};

export const useGetProfileUseridEmailAddressesEmailidVerifyHook = () => {
        const getProfileUseridEmailAddressesEmailidVerify = useMutator<unknown>();

        return useCallback((
    userId: string,
    emailId: string,
    params: GetProfileUseridEmailAddressesEmailidVerifyParams,
 signal?: AbortSignal
) => {
        return getProfileUseridEmailAddressesEmailidVerify(
          {url: `/profile/${userId}/email-addresses/${emailId}/verify`, method: 'GET',
        params, signal
    },
          );
        }, [getProfileUseridEmailAddressesEmailidVerify])
      }
    

export const getGetProfileUseridEmailAddressesEmailidVerifyQueryKey = (userId?: string,
    emailId?: string,
    params?: GetProfileUseridEmailAddressesEmailidVerifyParams,) => {
    return [`/profile/${userId}/email-addresses/${emailId}/verify`, ...(params ? [params]: [])] as const;
    }

    
export const useGetProfileUseridEmailAddressesEmailidVerifyQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>, TError = null | AppError | AppError | AppError | AppError | AppError>(userId: string,
    emailId: string,
    params: GetProfileUseridEmailAddressesEmailidVerifyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileUseridEmailAddressesEmailidVerifyQueryKey(userId,emailId,params);

  const getProfileUseridEmailAddressesEmailidVerify =  useGetProfileUseridEmailAddressesEmailidVerifyHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>> = ({ signal }) => getProfileUseridEmailAddressesEmailidVerify(userId,emailId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId && emailId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileUseridEmailAddressesEmailidVerifyQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>>
export type GetProfileUseridEmailAddressesEmailidVerifyQueryError = null | AppError | AppError | AppError | AppError | AppError


export function useGetProfileUseridEmailAddressesEmailidVerify<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>, TError = null | AppError | AppError | AppError | AppError | AppError>(
 userId: string,
    emailId: string,
    params: GetProfileUseridEmailAddressesEmailidVerifyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileUseridEmailAddressesEmailidVerify<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>, TError = null | AppError | AppError | AppError | AppError | AppError>(
 userId: string,
    emailId: string,
    params: GetProfileUseridEmailAddressesEmailidVerifyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileUseridEmailAddressesEmailidVerify<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>, TError = null | AppError | AppError | AppError | AppError | AppError>(
 userId: string,
    emailId: string,
    params: GetProfileUseridEmailAddressesEmailidVerifyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProfileUseridEmailAddressesEmailidVerify<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>, TError = null | AppError | AppError | AppError | AppError | AppError>(
 userId: string,
    emailId: string,
    params: GetProfileUseridEmailAddressesEmailidVerifyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidVerifyHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetProfileUseridEmailAddressesEmailidVerifyQueryOptions(userId,emailId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostProfileAddressesHook = () => {
        const postProfileAddresses = useMutator<ReceiverProfile>();

        return useCallback((
    addressRequest: AddressRequest,
 signal?: AbortSignal
) => {
        return postProfileAddresses(
          {url: `/profile/addresses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addressRequest, signal
    },
          );
        }, [postProfileAddresses])
      }
    


export const usePostProfileAddressesMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileAddressesHook>>>, TError,{data: AddressRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileAddressesHook>>>, TError,{data: AddressRequest}, TContext> => {

const mutationKey = ['postProfileAddresses'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postProfileAddresses =  usePostProfileAddressesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostProfileAddressesHook>>>, {data: AddressRequest}> = (props) => {
          const {data} = props ?? {};

          return  postProfileAddresses(data,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PostProfileAddressesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostProfileAddressesHook>>>>
    export type PostProfileAddressesMutationBody = AddressRequest
    export type PostProfileAddressesMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePostProfileAddresses = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileAddressesHook>>>, TError,{data: AddressRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostProfileAddressesHook>>>,
        TError,
        {data: AddressRequest},
        TContext
      > => {

      const mutationOptions = usePostProfileAddressesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePostProfileInteractionsNameHook = () => {
        const postProfileInteractionsName = useMutator<ReceiverProfile>();

        return useCallback((
    name: string,
 signal?: AbortSignal
) => {
        return postProfileInteractionsName(
          {url: `/profile/interactions/${name}`, method: 'POST', signal
    },
          );
        }, [postProfileInteractionsName])
      }
    


export const usePostProfileInteractionsNameMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileInteractionsNameHook>>>, TError,{name: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileInteractionsNameHook>>>, TError,{name: string}, TContext> => {

const mutationKey = ['postProfileInteractionsName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postProfileInteractionsName =  usePostProfileInteractionsNameHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostProfileInteractionsNameHook>>>, {name: string}> = (props) => {
          const {name} = props ?? {};

          return  postProfileInteractionsName(name,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PostProfileInteractionsNameMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostProfileInteractionsNameHook>>>>
    
    export type PostProfileInteractionsNameMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePostProfileInteractionsName = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileInteractionsNameHook>>>, TError,{name: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostProfileInteractionsNameHook>>>,
        TError,
        {name: string},
        TContext
      > => {

      const mutationOptions = usePostProfileInteractionsNameMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetNotificationPreferencesHook = () => {
        const getNotificationPreferences = useMutator<NotificationPreferences>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getNotificationPreferences(
          {url: `/notification-preferences`, method: 'GET', signal
    },
          );
        }, [getNotificationPreferences])
      }
    

export const getGetNotificationPreferencesQueryKey = () => {
    return [`/notification-preferences`] as const;
    }

    
export const useGetNotificationPreferencesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>, TError = AppError | AppError | AppError | AppError | AppError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationPreferencesQueryKey();

  const getNotificationPreferences =  useGetNotificationPreferencesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>> = ({ signal }) => getNotificationPreferences(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationPreferencesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>>
export type GetNotificationPreferencesQueryError = AppError | AppError | AppError | AppError | AppError


export function useGetNotificationPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNotificationPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationPreferencesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetNotificationPreferencesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutProfileEmailAddressesEmailidReActivateHook = () => {
        const putProfileEmailAddressesEmailidReActivate = useMutator<ReceiverProfile>();

        return useCallback((
    emailId: string,
    params?: PutProfileEmailAddressesEmailidReActivateParams,
 ) => {
        return putProfileEmailAddressesEmailidReActivate(
          {url: `/profile/email-addresses/${emailId}/re-activate`, method: 'PUT',
        params
    },
          );
        }, [putProfileEmailAddressesEmailidReActivate])
      }
    


export const usePutProfileEmailAddressesEmailidReActivateMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileEmailAddressesEmailidReActivateHook>>>, TError,{emailId: string;params?: PutProfileEmailAddressesEmailidReActivateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileEmailAddressesEmailidReActivateHook>>>, TError,{emailId: string;params?: PutProfileEmailAddressesEmailidReActivateParams}, TContext> => {

const mutationKey = ['putProfileEmailAddressesEmailidReActivate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putProfileEmailAddressesEmailidReActivate =  usePutProfileEmailAddressesEmailidReActivateHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutProfileEmailAddressesEmailidReActivateHook>>>, {emailId: string;params?: PutProfileEmailAddressesEmailidReActivateParams}> = (props) => {
          const {emailId,params} = props ?? {};

          return  putProfileEmailAddressesEmailidReActivate(emailId,params,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PutProfileEmailAddressesEmailidReActivateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutProfileEmailAddressesEmailidReActivateHook>>>>
    
    export type PutProfileEmailAddressesEmailidReActivateMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePutProfileEmailAddressesEmailidReActivate = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileEmailAddressesEmailidReActivateHook>>>, TError,{emailId: string;params?: PutProfileEmailAddressesEmailidReActivateParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutProfileEmailAddressesEmailidReActivateHook>>>,
        TError,
        {emailId: string;params?: PutProfileEmailAddressesEmailidReActivateParams},
        TContext
      > => {

      const mutationOptions = usePutProfileEmailAddressesEmailidReActivateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteProfileEmailAddressesEmailidHook = () => {
        const deleteProfileEmailAddressesEmailid = useMutator<ReceiverProfile>();

        return useCallback((
    emailId: string,
 ) => {
        return deleteProfileEmailAddressesEmailid(
          {url: `/profile/email-addresses/${emailId}`, method: 'DELETE'
    },
          );
        }, [deleteProfileEmailAddressesEmailid])
      }
    


export const useDeleteProfileEmailAddressesEmailidMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteProfileEmailAddressesEmailidHook>>>, TError,{emailId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteProfileEmailAddressesEmailidHook>>>, TError,{emailId: string}, TContext> => {

const mutationKey = ['deleteProfileEmailAddressesEmailid'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteProfileEmailAddressesEmailid =  useDeleteProfileEmailAddressesEmailidHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteProfileEmailAddressesEmailidHook>>>, {emailId: string}> = (props) => {
          const {emailId} = props ?? {};

          return  deleteProfileEmailAddressesEmailid(emailId,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type DeleteProfileEmailAddressesEmailidMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteProfileEmailAddressesEmailidHook>>>>
    
    export type DeleteProfileEmailAddressesEmailidMutationError = AppError | AppError | AppError | AppError | AppError

    export const useDeleteProfileEmailAddressesEmailid = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteProfileEmailAddressesEmailidHook>>>, TError,{emailId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteProfileEmailAddressesEmailidHook>>>,
        TError,
        {emailId: string},
        TContext
      > => {

      const mutationOptions = useDeleteProfileEmailAddressesEmailidMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePostNotificationPreferencesPushNotificationPreferencesHook = () => {
        const postNotificationPreferencesPushNotificationPreferences = useMutator<NotificationPreferences>();

        return useCallback((
    updatePushNotificationPreference: UpdatePushNotificationPreference,
 signal?: AbortSignal
) => {
        return postNotificationPreferencesPushNotificationPreferences(
          {url: `/notification-preferences/push-notification-preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updatePushNotificationPreference, signal
    },
          );
        }, [postNotificationPreferencesPushNotificationPreferences])
      }
    


export const usePostNotificationPreferencesPushNotificationPreferencesMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesPushNotificationPreferencesHook>>>, TError,{data: UpdatePushNotificationPreference}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesPushNotificationPreferencesHook>>>, TError,{data: UpdatePushNotificationPreference}, TContext> => {

const mutationKey = ['postNotificationPreferencesPushNotificationPreferences'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postNotificationPreferencesPushNotificationPreferences =  usePostNotificationPreferencesPushNotificationPreferencesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesPushNotificationPreferencesHook>>>, {data: UpdatePushNotificationPreference}> = (props) => {
          const {data} = props ?? {};

          return  postNotificationPreferencesPushNotificationPreferences(data,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PostNotificationPreferencesPushNotificationPreferencesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesPushNotificationPreferencesHook>>>>
    export type PostNotificationPreferencesPushNotificationPreferencesMutationBody = UpdatePushNotificationPreference
    export type PostNotificationPreferencesPushNotificationPreferencesMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePostNotificationPreferencesPushNotificationPreferences = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesPushNotificationPreferencesHook>>>, TError,{data: UpdatePushNotificationPreference}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesPushNotificationPreferencesHook>>>,
        TError,
        {data: UpdatePushNotificationPreference},
        TContext
      > => {

      const mutationOptions = usePostNotificationPreferencesPushNotificationPreferencesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePutProfileAddressesAddressidHook = () => {
        const putProfileAddressesAddressid = useMutator<ReceiverProfile>();

        return useCallback((
    addressId: string,
    addressRequest: AddressRequest,
 ) => {
        return putProfileAddressesAddressid(
          {url: `/profile/addresses/${addressId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: addressRequest
    },
          );
        }, [putProfileAddressesAddressid])
      }
    


export const usePutProfileAddressesAddressidMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileAddressesAddressidHook>>>, TError,{addressId: string;data: AddressRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileAddressesAddressidHook>>>, TError,{addressId: string;data: AddressRequest}, TContext> => {

const mutationKey = ['putProfileAddressesAddressid'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putProfileAddressesAddressid =  usePutProfileAddressesAddressidHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutProfileAddressesAddressidHook>>>, {addressId: string;data: AddressRequest}> = (props) => {
          const {addressId,data} = props ?? {};

          return  putProfileAddressesAddressid(addressId,data,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PutProfileAddressesAddressidMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutProfileAddressesAddressidHook>>>>
    export type PutProfileAddressesAddressidMutationBody = AddressRequest
    export type PutProfileAddressesAddressidMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePutProfileAddressesAddressid = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileAddressesAddressidHook>>>, TError,{addressId: string;data: AddressRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutProfileAddressesAddressidHook>>>,
        TError,
        {addressId: string;data: AddressRequest},
        TContext
      > => {

      const mutationOptions = usePutProfileAddressesAddressidMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteProfileAddressesAddressidHook = () => {
        const deleteProfileAddressesAddressid = useMutator<ReceiverProfile>();

        return useCallback((
    addressId: string,
 ) => {
        return deleteProfileAddressesAddressid(
          {url: `/profile/addresses/${addressId}`, method: 'DELETE'
    },
          );
        }, [deleteProfileAddressesAddressid])
      }
    


export const useDeleteProfileAddressesAddressidMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteProfileAddressesAddressidHook>>>, TError,{addressId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteProfileAddressesAddressidHook>>>, TError,{addressId: string}, TContext> => {

const mutationKey = ['deleteProfileAddressesAddressid'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteProfileAddressesAddressid =  useDeleteProfileAddressesAddressidHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteProfileAddressesAddressidHook>>>, {addressId: string}> = (props) => {
          const {addressId} = props ?? {};

          return  deleteProfileAddressesAddressid(addressId,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type DeleteProfileAddressesAddressidMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteProfileAddressesAddressidHook>>>>
    
    export type DeleteProfileAddressesAddressidMutationError = AppError | AppError | AppError | AppError | AppError

    export const useDeleteProfileAddressesAddressid = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteProfileAddressesAddressidHook>>>, TError,{addressId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteProfileAddressesAddressidHook>>>,
        TError,
        {addressId: string},
        TContext
      > => {

      const mutationOptions = useDeleteProfileAddressesAddressidMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePutProfileMobilePhoneVerifyHook = () => {
        const putProfileMobilePhoneVerify = useMutator<ReceiverProfile>();

        return useCallback((
    verifyMobilePhoneRequest: VerifyMobilePhoneRequest,
 ) => {
        return putProfileMobilePhoneVerify(
          {url: `/profile/mobile-phone/verify`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: verifyMobilePhoneRequest
    },
          );
        }, [putProfileMobilePhoneVerify])
      }
    


export const usePutProfileMobilePhoneVerifyMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneVerifyHook>>>, TError,{data: VerifyMobilePhoneRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneVerifyHook>>>, TError,{data: VerifyMobilePhoneRequest}, TContext> => {

const mutationKey = ['putProfileMobilePhoneVerify'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putProfileMobilePhoneVerify =  usePutProfileMobilePhoneVerifyHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneVerifyHook>>>, {data: VerifyMobilePhoneRequest}> = (props) => {
          const {data} = props ?? {};

          return  putProfileMobilePhoneVerify(data,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PutProfileMobilePhoneVerifyMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneVerifyHook>>>>
    export type PutProfileMobilePhoneVerifyMutationBody = VerifyMobilePhoneRequest
    export type PutProfileMobilePhoneVerifyMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePutProfileMobilePhoneVerify = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneVerifyHook>>>, TError,{data: VerifyMobilePhoneRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneVerifyHook>>>,
        TError,
        {data: VerifyMobilePhoneRequest},
        TContext
      > => {

      const mutationOptions = usePutProfileMobilePhoneVerifyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePutProfileMobilePhoneValidateHook = () => {
        const putProfileMobilePhoneValidate = useMutator<ReceiverProfile>();

        return useCallback((
    
 ) => {
        return putProfileMobilePhoneValidate(
          {url: `/profile/mobile-phone/validate`, method: 'PUT'
    },
          );
        }, [putProfileMobilePhoneValidate])
      }
    


export const usePutProfileMobilePhoneValidateMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneValidateHook>>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneValidateHook>>>, TError,void, TContext> => {

const mutationKey = ['putProfileMobilePhoneValidate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putProfileMobilePhoneValidate =  usePutProfileMobilePhoneValidateHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneValidateHook>>>, void> = () => {
          

          return  putProfileMobilePhoneValidate()
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PutProfileMobilePhoneValidateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneValidateHook>>>>
    
    export type PutProfileMobilePhoneValidateMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePutProfileMobilePhoneValidate = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneValidateHook>>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneValidateHook>>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = usePutProfileMobilePhoneValidateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetProfileHook = () => {
        const getProfile = useMutator<ReceiverProfile>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getProfile(
          {url: `/profile`, method: 'GET', signal
    },
          );
        }, [getProfile])
      }
    

export const getGetProfileQueryKey = () => {
    return [`/profile`] as const;
    }

    
export const useGetProfileQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>, TError = AppError | AppError | AppError | AppError | AppError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileQueryKey();

  const getProfile =  useGetProfileHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>> = ({ signal }) => getProfile(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>>
export type GetProfileQueryError = AppError | AppError | AppError | AppError | AppError


export function useGetProfile<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfile<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProfile<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetProfileQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetProfileEmailAddressesHook = () => {
        const getProfileEmailAddresses = useMutator<ProfileEmailAddress[]>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getProfileEmailAddresses(
          {url: `/profile/email-addresses`, method: 'GET', signal
    },
          );
        }, [getProfileEmailAddresses])
      }
    

export const getGetProfileEmailAddressesQueryKey = () => {
    return [`/profile/email-addresses`] as const;
    }

    
export const useGetProfileEmailAddressesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>, TError = AppError | AppError | AppError | AppError | AppError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileEmailAddressesQueryKey();

  const getProfileEmailAddresses =  useGetProfileEmailAddressesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>> = ({ signal }) => getProfileEmailAddresses(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileEmailAddressesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>>
export type GetProfileEmailAddressesQueryError = AppError | AppError | AppError | AppError | AppError


export function useGetProfileEmailAddresses<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileEmailAddresses<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileEmailAddresses<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProfileEmailAddresses<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileEmailAddressesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetProfileEmailAddressesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostProfileEmailAddressesHook = () => {
        const postProfileEmailAddresses = useMutator<ReceiverProfile>();

        return useCallback((
    additionalEmailRequest: AdditionalEmailRequest,
    params?: PostProfileEmailAddressesParams,
 signal?: AbortSignal
) => {
        return postProfileEmailAddresses(
          {url: `/profile/email-addresses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: additionalEmailRequest,
        params, signal
    },
          );
        }, [postProfileEmailAddresses])
      }
    


export const usePostProfileEmailAddressesMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileEmailAddressesHook>>>, TError,{data: AdditionalEmailRequest;params?: PostProfileEmailAddressesParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileEmailAddressesHook>>>, TError,{data: AdditionalEmailRequest;params?: PostProfileEmailAddressesParams}, TContext> => {

const mutationKey = ['postProfileEmailAddresses'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postProfileEmailAddresses =  usePostProfileEmailAddressesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostProfileEmailAddressesHook>>>, {data: AdditionalEmailRequest;params?: PostProfileEmailAddressesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postProfileEmailAddresses(data,params,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PostProfileEmailAddressesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostProfileEmailAddressesHook>>>>
    export type PostProfileEmailAddressesMutationBody = AdditionalEmailRequest
    export type PostProfileEmailAddressesMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePostProfileEmailAddresses = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileEmailAddressesHook>>>, TError,{data: AdditionalEmailRequest;params?: PostProfileEmailAddressesParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostProfileEmailAddressesHook>>>,
        TError,
        {data: AdditionalEmailRequest;params?: PostProfileEmailAddressesParams},
        TContext
      > => {

      const mutationOptions = usePostProfileEmailAddressesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePutProfileMobilePhoneReActivateHook = () => {
        const putProfileMobilePhoneReActivate = useMutator<ReceiverProfile>();

        return useCallback((
    params?: PutProfileMobilePhoneReActivateParams,
 ) => {
        return putProfileMobilePhoneReActivate(
          {url: `/profile/mobile-phone/re-activate`, method: 'PUT',
        params
    },
          );
        }, [putProfileMobilePhoneReActivate])
      }
    


export const usePutProfileMobilePhoneReActivateMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneReActivateHook>>>, TError,{params?: PutProfileMobilePhoneReActivateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneReActivateHook>>>, TError,{params?: PutProfileMobilePhoneReActivateParams}, TContext> => {

const mutationKey = ['putProfileMobilePhoneReActivate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putProfileMobilePhoneReActivate =  usePutProfileMobilePhoneReActivateHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneReActivateHook>>>, {params?: PutProfileMobilePhoneReActivateParams}> = (props) => {
          const {params} = props ?? {};

          return  putProfileMobilePhoneReActivate(params,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PutProfileMobilePhoneReActivateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneReActivateHook>>>>
    
    export type PutProfileMobilePhoneReActivateMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePutProfileMobilePhoneReActivate = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneReActivateHook>>>, TError,{params?: PutProfileMobilePhoneReActivateParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutProfileMobilePhoneReActivateHook>>>,
        TError,
        {params?: PutProfileMobilePhoneReActivateParams},
        TContext
      > => {

      const mutationOptions = usePutProfileMobilePhoneReActivateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetProfilePictureHook = () => {
        const getProfilePicture = useMutator<Blob>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getProfilePicture(
          {url: `/profile/picture`, method: 'GET',
        responseType: 'blob', signal
    },
          );
        }, [getProfilePicture])
      }
    

export const getGetProfilePictureQueryKey = () => {
    return [`/profile/picture`] as const;
    }

    
export const useGetProfilePictureQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>, TError = AppError | AppError | AppError | AppError | AppError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfilePictureQueryKey();

  const getProfilePicture =  useGetProfilePictureHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>> = ({ signal }) => getProfilePicture(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfilePictureQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>>
export type GetProfilePictureQueryError = AppError | AppError | AppError | AppError | AppError


export function useGetProfilePicture<TData = Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfilePicture<TData = Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfilePicture<TData = Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProfilePicture<TData = Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>, TError = AppError | AppError | AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfilePictureHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetProfilePictureQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutProfilePictureHook = () => {
        const putProfilePicture = useMutator<null>();

        return useCallback((
    putProfilePictureBody: Blob,
 ) => {
        return putProfilePicture(
          {url: `/profile/picture`, method: 'PUT',
      headers: {'Content-Type': 'application/octet-stream', },
      data: putProfilePictureBody
    },
          );
        }, [putProfilePicture])
      }
    


export const usePutProfilePictureMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfilePictureHook>>>, TError,{data: Blob}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfilePictureHook>>>, TError,{data: Blob}, TContext> => {

const mutationKey = ['putProfilePicture'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putProfilePicture =  usePutProfilePictureHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutProfilePictureHook>>>, {data: Blob}> = (props) => {
          const {data} = props ?? {};

          return  putProfilePicture(data,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PutProfilePictureMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutProfilePictureHook>>>>
    export type PutProfilePictureMutationBody = Blob
    export type PutProfilePictureMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePutProfilePicture = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutProfilePictureHook>>>, TError,{data: Blob}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutProfilePictureHook>>>,
        TError,
        {data: Blob},
        TContext
      > => {

      const mutationOptions = usePutProfilePictureMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePostProfileMobilePhoneHook = () => {
        const postProfileMobilePhone = useMutator<ReceiverProfile>();

        return useCallback((
    mobilePhoneRequest: MobilePhoneRequest,
    params?: PostProfileMobilePhoneParams,
 signal?: AbortSignal
) => {
        return postProfileMobilePhone(
          {url: `/profile/mobile-phone`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mobilePhoneRequest,
        params, signal
    },
          );
        }, [postProfileMobilePhone])
      }
    


export const usePostProfileMobilePhoneMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileMobilePhoneHook>>>, TError,{data: MobilePhoneRequest;params?: PostProfileMobilePhoneParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileMobilePhoneHook>>>, TError,{data: MobilePhoneRequest;params?: PostProfileMobilePhoneParams}, TContext> => {

const mutationKey = ['postProfileMobilePhone'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postProfileMobilePhone =  usePostProfileMobilePhoneHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostProfileMobilePhoneHook>>>, {data: MobilePhoneRequest;params?: PostProfileMobilePhoneParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postProfileMobilePhone(data,params,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PostProfileMobilePhoneMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostProfileMobilePhoneHook>>>>
    export type PostProfileMobilePhoneMutationBody = MobilePhoneRequest
    export type PostProfileMobilePhoneMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePostProfileMobilePhone = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileMobilePhoneHook>>>, TError,{data: MobilePhoneRequest;params?: PostProfileMobilePhoneParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostProfileMobilePhoneHook>>>,
        TError,
        {data: MobilePhoneRequest;params?: PostProfileMobilePhoneParams},
        TContext
      > => {

      const mutationOptions = usePostProfileMobilePhoneMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteProfileMobilePhoneHook = () => {
        const deleteProfileMobilePhone = useMutator<ReceiverProfile>();

        return useCallback((
    
 ) => {
        return deleteProfileMobilePhone(
          {url: `/profile/mobile-phone`, method: 'DELETE'
    },
          );
        }, [deleteProfileMobilePhone])
      }
    


export const useDeleteProfileMobilePhoneMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteProfileMobilePhoneHook>>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteProfileMobilePhoneHook>>>, TError,void, TContext> => {

const mutationKey = ['deleteProfileMobilePhone'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteProfileMobilePhone =  useDeleteProfileMobilePhoneHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteProfileMobilePhoneHook>>>, void> = () => {
          

          return  deleteProfileMobilePhone()
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type DeleteProfileMobilePhoneMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteProfileMobilePhoneHook>>>>
    
    export type DeleteProfileMobilePhoneMutationError = AppError | AppError | AppError | AppError | AppError

    export const useDeleteProfileMobilePhone = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteProfileMobilePhoneHook>>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteProfileMobilePhoneHook>>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = useDeleteProfileMobilePhoneMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePostNotificationPreferencesEmailNotificationPreferencesHook = () => {
        const postNotificationPreferencesEmailNotificationPreferences = useMutator<NotificationPreferences>();

        return useCallback((
    updateEmailNotificationPreference: UpdateEmailNotificationPreference,
 signal?: AbortSignal
) => {
        return postNotificationPreferencesEmailNotificationPreferences(
          {url: `/notification-preferences/email-notification-preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateEmailNotificationPreference, signal
    },
          );
        }, [postNotificationPreferencesEmailNotificationPreferences])
      }
    


export const usePostNotificationPreferencesEmailNotificationPreferencesMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesEmailNotificationPreferencesHook>>>, TError,{data: UpdateEmailNotificationPreference}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesEmailNotificationPreferencesHook>>>, TError,{data: UpdateEmailNotificationPreference}, TContext> => {

const mutationKey = ['postNotificationPreferencesEmailNotificationPreferences'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postNotificationPreferencesEmailNotificationPreferences =  usePostNotificationPreferencesEmailNotificationPreferencesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesEmailNotificationPreferencesHook>>>, {data: UpdateEmailNotificationPreference}> = (props) => {
          const {data} = props ?? {};

          return  postNotificationPreferencesEmailNotificationPreferences(data,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PostNotificationPreferencesEmailNotificationPreferencesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesEmailNotificationPreferencesHook>>>>
    export type PostNotificationPreferencesEmailNotificationPreferencesMutationBody = UpdateEmailNotificationPreference
    export type PostNotificationPreferencesEmailNotificationPreferencesMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePostNotificationPreferencesEmailNotificationPreferences = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesEmailNotificationPreferencesHook>>>, TError,{data: UpdateEmailNotificationPreference}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostNotificationPreferencesEmailNotificationPreferencesHook>>>,
        TError,
        {data: UpdateEmailNotificationPreference},
        TContext
      > => {

      const mutationOptions = usePostNotificationPreferencesEmailNotificationPreferencesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetProfileUseridEmailAddressesEmailidRetractHook = () => {
        const getProfileUseridEmailAddressesEmailidRetract = useMutator<unknown>();

        return useCallback((
    userId: string,
    emailId: string,
    params?: GetProfileUseridEmailAddressesEmailidRetractParams,
 signal?: AbortSignal
) => {
        return getProfileUseridEmailAddressesEmailidRetract(
          {url: `/profile/${userId}/email-addresses/${emailId}/retract`, method: 'GET',
        params, signal
    },
          );
        }, [getProfileUseridEmailAddressesEmailidRetract])
      }
    

export const getGetProfileUseridEmailAddressesEmailidRetractQueryKey = (userId?: string,
    emailId?: string,
    params?: GetProfileUseridEmailAddressesEmailidRetractParams,) => {
    return [`/profile/${userId}/email-addresses/${emailId}/retract`, ...(params ? [params]: [])] as const;
    }

    
export const useGetProfileUseridEmailAddressesEmailidRetractQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>, TError = null | AppError | AppError | AppError | AppError | AppError>(userId: string,
    emailId: string,
    params?: GetProfileUseridEmailAddressesEmailidRetractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfileUseridEmailAddressesEmailidRetractQueryKey(userId,emailId,params);

  const getProfileUseridEmailAddressesEmailidRetract =  useGetProfileUseridEmailAddressesEmailidRetractHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>> = ({ signal }) => getProfileUseridEmailAddressesEmailidRetract(userId,emailId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId && emailId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProfileUseridEmailAddressesEmailidRetractQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>>
export type GetProfileUseridEmailAddressesEmailidRetractQueryError = null | AppError | AppError | AppError | AppError | AppError


export function useGetProfileUseridEmailAddressesEmailidRetract<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>, TError = null | AppError | AppError | AppError | AppError | AppError>(
 userId: string,
    emailId: string,
    params: undefined |  GetProfileUseridEmailAddressesEmailidRetractParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileUseridEmailAddressesEmailidRetract<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>, TError = null | AppError | AppError | AppError | AppError | AppError>(
 userId: string,
    emailId: string,
    params?: GetProfileUseridEmailAddressesEmailidRetractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProfileUseridEmailAddressesEmailidRetract<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>, TError = null | AppError | AppError | AppError | AppError | AppError>(
 userId: string,
    emailId: string,
    params?: GetProfileUseridEmailAddressesEmailidRetractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProfileUseridEmailAddressesEmailidRetract<TData = Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>, TError = null | AppError | AppError | AppError | AppError | AppError>(
 userId: string,
    emailId: string,
    params?: GetProfileUseridEmailAddressesEmailidRetractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProfileUseridEmailAddressesEmailidRetractHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetProfileUseridEmailAddressesEmailidRetractQueryOptions(userId,emailId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostProfileGuidedTourTournameHook = () => {
        const postProfileGuidedTourTourname = useMutator<ReceiverProfile>();

        return useCallback((
    tourName: string,
 signal?: AbortSignal
) => {
        return postProfileGuidedTourTourname(
          {url: `/profile/guided-tour/${tourName}`, method: 'POST', signal
    },
          );
        }, [postProfileGuidedTourTourname])
      }
    


export const usePostProfileGuidedTourTournameMutationOptions = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileGuidedTourTournameHook>>>, TError,{tourName: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileGuidedTourTournameHook>>>, TError,{tourName: string}, TContext> => {

const mutationKey = ['postProfileGuidedTourTourname'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postProfileGuidedTourTourname =  usePostProfileGuidedTourTournameHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostProfileGuidedTourTournameHook>>>, {tourName: string}> = (props) => {
          const {tourName} = props ?? {};

          return  postProfileGuidedTourTourname(tourName,)
        }

        const customOptions = useCreateMutationOptions({...mutationOptions, mutationFn});


  return  customOptions}

    export type PostProfileGuidedTourTournameMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostProfileGuidedTourTournameHook>>>>
    
    export type PostProfileGuidedTourTournameMutationError = AppError | AppError | AppError | AppError | AppError

    export const usePostProfileGuidedTourTourname = <TError = AppError | AppError | AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostProfileGuidedTourTournameHook>>>, TError,{tourName: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostProfileGuidedTourTournameHook>>>,
        TError,
        {tourName: string},
        TContext
      > => {

      const mutationOptions = usePostProfileGuidedTourTournameMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
